import { CaseModule } from './../case/case.module';
import { QueryBuilderModule } from '../shared/query-builder/query-builder.module';
import { TaskModule } from '../task/task.module';
import { ProgramListComponent } from './program-list/program-list.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { ProgramCategoryListComponent } from './program-category/program-category-list/program-category-list.component';
import { ProgramCategoryEditComponent } from './program-category/program-category-edit/program-category-edit.component';
import { ProgramTemplateListComponent } from './program-template/program-template-list/program-template-list.component';
import { ProgramListWidgetComponent } from './program-list-widget/program-list-widget.component';
import { MessageModule } from '../message/message.module';
import { ChannelModule } from '../channel/channel.module';
import { ProgramEditComponent } from './program-edit/program-edit.component';
import { ChannelListService } from '../core/service/grid-data/grid-data-channel.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProgramDetailComponent } from './program-detail/program-detail.component';
import { ProgramWizardComponent } from './program-wizard/program-wizard.component';
import { ProgramAuditListComponent } from './program-audit/program-audit-list/program-audit-list.component';
import { ProgramAuditDetailsComponent } from './program-audit/program-audit-details/program-audit-details.component';

@NgModule({
  imports: [
    SharedModule,
    TaskModule,
    QueryBuilderModule,
    CaseModule,
    MessageModule,
    ChannelModule,
    NgbModule,
    ProgramAuditListComponent,
    ProgramAuditDetailsComponent
  ],
  exports: [
    ProgramListWidgetComponent,
  ],
  declarations: [
    ProgramListComponent,
    ProgramCategoryListComponent,
    ProgramCategoryEditComponent,
    ProgramTemplateListComponent,
    ProgramListWidgetComponent,
    ProgramEditComponent,
    ProgramDetailComponent,
    ProgramWizardComponent
  ],
  providers: [
    ChannelListService
  ]
})
export class ProgramModule { }
